module.exports = __webpack_public_path__ + "static/media/service.08eb4af2.svg";